<script lang="ts">
  import { cx } from '@agapi/ui/panda/css';
  import { skeletonStyles } from './skeleton.styles';
  import type { Component } from 'svelte';
    import type { SkeletonProps } from './skeleton.types';

  const {
    count = 1,
    width = undefined,
    height = undefined,
    aspectRatio = undefined,
    circle = false
   }: SkeletonProps = $props();

  let Wrapper = $state<Component | undefined>(undefined);

  let elements = $state<{ className: string; defaultStyles: string; style: { width?: string; height?: string; borderRadius?: string; aspectRatio?: string } }[]>([]);
  let style: { width?: string; height?: string; borderRadius?: string; aspectRatio?: string } = {};

  elements.length = 0;
  for (let i = 0; i < count; i++) {
    if (width !== null) {
      style.width = `${width}px`;
    }

    if (height !== null) {
      style.height = `${height}px`;
    }

    if (width !== null && height !== null && circle) {
      style.borderRadius = '50%';
    }

    if (aspectRatio !== null) {
      style.aspectRatio = `${aspectRatio}`;
    }

    const className = 'svelte-loader-skeleton';
    elements.push({
      className,
      defaultStyles: skeletonStyles(),
      style
    });
  }
</script>

{#if Wrapper}
  {#each elements as element}
    <span>
      <Wrapper>
        <span
          class={cx(element.className, element.defaultStyles)}
          style:width={element.style.width}
          style:border-radius={element.style.borderRadius}
          style:height={element.style.height}
          style:aspect-ratio={element.style.aspectRatio}
        >
          &zwnj;
        </span>
      </Wrapper>
    </span>
  {/each}
{:else}
  {#each elements as element}
    <span
      class="{element.className} {element.defaultStyles}"
      style:width={element.style.width}
      style:border-radius={element.style.borderRadius}
      style:height={element.style.height}
      style:aspect-ratio={element.style.aspectRatio}
    >
      &zwnj;
    </span>
  {/each}
{/if}
